var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavWhattodoMondorf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M23.1,17.7v5.4h-5.4c-1.4,0-2.8-0.6-3.8-1.6s-1.5-2.3-1.6-3.7h0.8c0,1.2,0.5,2.3,1.3,3.1 c0.8,0.9,2,1.3,3.2,1.3h4.5v-4.5c0-1.2-0.5-2.4-1.3-3.2s-2-1.3-3.1-1.3v-0.8c1.4,0,2.7,0.6,3.7,1.6C22.5,14.9,23.1,16.3,23.1,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M23.1,6.3c0,1.4-0.5,2.8-1.6,3.8c-1,1-2.3,1.6-3.7,1.6v-0.9c1.2,0,2.3-0.5,3.1-1.3c0.8-0.9,1.3-2,1.3-3.2V1.8 h-4.5c-1.2,0-2.3,0.5-3.2,1.3c-0.8,0.8-1.3,1.9-1.3,3.1h-0.8c0-1.4,0.6-2.7,1.6-3.7s2.4-1.6,3.8-1.6h5.4L23.1,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M11.6,6.2h-0.8c0-1.2-0.5-2.3-1.3-3.1c-0.8-0.9-2-1.3-3.2-1.3H1.8v4.5c0,1.2,0.5,2.3,1.3,3.2 c0.8,0.8,2,1.3,3.1,1.3v0.9c-1.4,0-2.7-0.6-3.7-1.6S0.9,7.7,0.9,6.3V0.9h5.4c1.4,0,2.8,0.6,3.8,1.6C11.1,3.5,11.6,4.8,11.6,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M11.6,17.8c0,1.4-0.6,2.7-1.6,3.7s-2.4,1.6-3.8,1.6H0.8v-5.4c0-1.4,0.5-2.8,1.6-3.8c1-1,2.3-1.6,3.7-1.6v0.8 c-1.2,0-2.3,0.5-3.1,1.3c-0.8,0.9-1.3,2-1.3,3.2v4.5h4.5c1.2,0,2.3-0.5,3.2-1.3c0.8-0.8,1.3-1.9,1.3-3.1L11.6,17.8L11.6,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M12.5,14.1l-0.2,0.1v-3.3c0.1,0.1,0.2,0.2,0.4,0.3C13.5,12.1,13.4,13.4,12.5,14.1 M14.4,10.3L12,7.9l-2.4,2.4 c-1.3,1.3-1.3,3.4,0,4.7s3.4,1.3,4.7,0C15.7,13.7,15.7,11.6,14.4,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M5,5.2V5l2.4,2.4c-0.2,0-0.3,0-0.5,0C5.8,7.3,4.9,6.4,5,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M19,18.8V19l-2.4-2.4c0.2,0,0.3,0,0.5,0C18.2,16.7,19.1,17.6,19,18.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M5.3,19H5.1l2.4-2.4c0,0.2,0,0.3,0,0.5C7.4,18.2,6.4,19.1,5.3,19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M18.7,5H19l-2.4,2.4c0-0.2,0-0.3,0-0.5C16.7,5.8,17.6,4.9,18.7,5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavWhattodoMondorf);
export default __webpack_public_path__ + "static/media/nav_whattodo_mondorf.f50f57ab81d87156286bf6a8e6d84c4f.svg";
export { ForwardRef as ReactComponent };